/**
 * @generated SignedSource<<89cf34fec540d91f13801b684de2b3fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type Colors = "BLUE" | "GREEN" | "NO_COLOR" | "ORANGE" | "PURPLE" | "RED" | "YELLOW";
export type PrivateNotesPanelListQuery$variables = {
  id: string;
};
export type PrivateNotesPanelListQuery$data = {
  readonly stream: {
    readonly privateNotes?: ReadonlyArray<{
      readonly id: string;
      readonly linkedNote: {
        readonly createdAt: string | null;
        readonly eventStart: string | null;
        readonly id: string;
        readonly url: string | null;
      } | null;
      readonly note: {
        readonly id: string;
      };
      readonly title: string | null;
    }>;
  } | null;
  readonly viewer: {
    readonly account: {
      readonly allowCompleteByAny: boolean;
      readonly billingAccount: {
        readonly featureAccess: any;
        readonly hasAccessToDuedates: boolean;
        readonly hasAccessToEmbeds: boolean;
        readonly hasAccessToMultipleAssignees: boolean;
        readonly hasAccessToObjectives: boolean;
      };
      readonly id: string;
      readonly tags: ReadonlyArray<{
        readonly __typename: "Tag";
        readonly color: Colors;
        readonly id: string;
        readonly label: string;
      }>;
    };
    readonly uxSimplificationEnabled: boolean;
  };
};
export type PrivateNotesPanelListQuery = {
  response: PrivateNotesPanelListQuery$data;
  variables: PrivateNotesPanelListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uxSimplificationEnabled",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": "hasAccessToDuedates",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "duedates"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"duedates\")"
},
v4 = {
  "alias": "hasAccessToEmbeds",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "embeds"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"embeds\")"
},
v5 = {
  "alias": "hasAccessToObjectives",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "objectives"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"objectives\")"
},
v6 = {
  "alias": "hasAccessToMultipleAssignees",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "multiple_assignees"
    }
  ],
  "kind": "ScalarField",
  "name": "hasAccessToFeature",
  "storageKey": "hasAccessToFeature(feature:\"multiple_assignees\")"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "featureAccess",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allowCompleteByAny",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "Tag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PrivateNote",
      "kind": "LinkedField",
      "name": "privateNotes",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "kind": "LinkedField",
          "name": "linkedNote",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "eventStart",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "createdAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "kind": "LinkedField",
          "name": "note",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PrivateNotesPanelListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "stream",
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PrivateNotesPanelListQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v8/*: any*/),
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "stream",
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v9/*: any*/),
          (v12/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7bbb0f9955e8e63f8c2a3b9a18d1a31",
    "id": null,
    "metadata": {},
    "name": "PrivateNotesPanelListQuery",
    "operationKind": "query",
    "text": "query PrivateNotesPanelListQuery(\n  $id: ID!\n) {\n  viewer {\n    uxSimplificationEnabled\n    account {\n      id\n      billingAccount {\n        hasAccessToDuedates: hasAccessToFeature(feature: duedates)\n        hasAccessToEmbeds: hasAccessToFeature(feature: embeds)\n        hasAccessToObjectives: hasAccessToFeature(feature: objectives)\n        hasAccessToMultipleAssignees: hasAccessToFeature(feature: multiple_assignees)\n        featureAccess\n        id\n      }\n      allowCompleteByAny\n      tags {\n        __typename\n        id\n        label\n        color\n      }\n    }\n    id\n  }\n  stream: node(id: $id) {\n    __typename\n    ... on NoteStream {\n      privateNotes {\n        id\n        title\n        linkedNote {\n          id\n          eventStart\n          createdAt\n          url\n        }\n        note {\n          id\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1228a023c003dddbf3ca11806b8c3325";

export default node;
